/* eslint-disable import/no-import-module-exports */
import {configureStore} from '@reduxjs/toolkit';
import {api} from './api';
import errorMiddleware from './errorMiddleware';
import rootReducer from './reducers';

const store = configureStore({
  reducer: rootReducer,
  middleware: getDefaultMiddleware => getDefaultMiddleware()
    .concat(api.middleware)
    .concat(errorMiddleware),
  devTools: window.env.NODE_ENV === 'development',
});

if (window.env.NODE_ENV !== 'production' && module.hot) {
  module.hot.accept('./reducers', () => store.replaceReducer(rootReducer));
}

export default store;
